export class paginationController {
    selfPageChange: boolean;
    pageChange: any;
    pageNumber
    constructor(private $state, private $rootScope) {
        "ngInject"

    }
    changePage() {
        if (this.selfPageChange) {
            this.pageChange({ pageNumber: this.pageNumber })
        }
        else {

            let url = this.$state.params.params || "";
            let urlArray = url && url.split('/') || [];
            let newUrl;
            let index = urlArray.indexOf('pageNumber');
            if (index > -1) {
                // if sortItem exist in Url
                newUrl = url.replace('pageNumber' + '/' + urlArray[index + 1], 'pageNumber' + '/' + this.pageNumber)

            }
            else {
                let addonUrl = `pageNumber/${this.pageNumber}/`
                newUrl = url + addonUrl;
            }
            this.$state.params.params = newUrl;
            this.$state.go(this.$state.current, this.$state.params)
            this.$rootScope.$emit('$routeChangeSuccess')
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/pagination/pagination.controller.ts